var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0ZM36.2432 21.2498L23.695 33.7979C22.9871 34.5058 22.0268 34.9036 21.0255 34.9036C20.0243 34.9036 19.064 34.5058 18.356 33.7978L11.7571 27.1988C10.2828 25.7245 10.2828 23.3342 11.7572 21.8598C13.2316 20.3856 15.6219 20.3855 17.0963 21.8599L21.0256 25.7894L30.9041 15.9109C32.3785 14.4366 34.7688 14.4366 36.2433 15.911C37.7174 17.385 37.7174 19.7754 36.2432 21.2498Z",
    fill: "#91B848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.46e9ede792c501f6a00309403acef3cd.svg";
export { ForwardRef as ReactComponent };